const cwsCarousels = () => {
  let checkDuration = '';
  let multipleSlides = false;
  if ( document.querySelector('.custom-carousel') ) {
    checkDuration = document.querySelector('.custom-carousel').getAttribute('data-duration');
    checkSlides = document.querySelector('.custom-carousel').getAttribute('data-slides');
    if ( checkSlides > 1 ) {
      multipleSlides = true;
    }
  }

  const highlightSwiper = new Swiper(".highlight-swiper", {
    slidesPerView: 1,
    loop: multipleSlides,
    autoHeight: true,
    autoplay: {
      delay: checkDuration,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 800,
    // Navigation arrows
    navigation: {
      nextEl: ".highlight-button-next",
      prevEl: ".highlight-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      768: {
        slidesPerView: 1,
      },
    },
  });

  const calcArrowsPosition = () => {
    const highlightCaption = document.querySelectorAll(
      ".highlight-slide__caption"
    );
    const prevBtn = document.querySelector(".highlight-button-prev");
    const nextBtn = document.querySelector(".highlight-button-next");
    let boxHeight = 0;

    if (prevBtn !== null && nextBtn !== null) {
      highlightCaption.forEach((box) => {
        prevBtn.style.bottom = "";
        nextBtn.style.bottom = "";

        if (box.clientHeight > boxHeight) {
          boxHeight = box.clientHeight;
        }
      });

      if (window.screen.width > 767) {
        prevBtn.style.bottom = `${boxHeight / 2 + 10}px`;
        nextBtn.style.bottom = `${boxHeight / 2 - 80}px`;
      } else {
        prevBtn.style.bottom = "";
        nextBtn.style.bottom = "";
      }
    }
  };

  calcArrowsPosition();

  window.addEventListener("resize", () => {
    calcArrowsPosition();
  });
};

const cwsSetCookie = (name, value, options = {}) => {
  options = {
    path: "/",
    ...options,
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie =
      encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
};

const cwsGetCookie = (name) => {
  let matches = document.cookie.match(
      new RegExp(
          "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
      )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

document.addEventListener("DOMContentLoaded", () => {
  cwsCarousels();
});
